import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import './styles/Career.css';
import career from './images/career.png';
import career2 from './images/career2.jpg';
import { useEffect, useState } from 'react';
import lotus from './images/lotus2.png';
import Swal from 'sweetalert2';

const Career = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
      const handleScroll = () => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;            
    
        if (scrollTop > 50) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      };
    
      window.addEventListener("scroll", handleScroll);
      handleScroll();
    
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);

    const overview = ()=>{
      window.location.href='#top';
    }
    
    const opportunity = ()=>{
      window.location.href='#Opportunities';
    }

    const [formData, setFormData] = useState({
      name: '',
      contact: '',
      email: '',
      message: '',
    });
    
    const [attachments, setAttachments] = useState([]);

    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    };
    
    const handleFileChange = (e) => {
      setAttachments(e.target.files);
    };

    const handleSubmit = async () => {
      const data = new FormData();
      data.append('name', formData.name);
      data.append('contact', formData.contact);
      data.append('email', formData.email);
      data.append('message', formData.message);
    
      for (let i = 0; i < attachments.length; i++) {
        data.append('attachments', attachments[i]);
      }
    
      try {
        const res = await fetch('https://law-s8zl.onrender.com/api/sendCareerMail', {
          method: 'POST',
          body: data
        });
    
        if (res.ok) {
          Swal.fire({
            icon: 'success',
            title: 'Application Sent!',
            text: 'We have received your details and will get back to you soon.',
            confirmButtonColor: '#198754' // Bootstrap green
          });
    
          setFormData({ name: '', contact: '', email: '', message: '' });
          setAttachments([]);
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: 'Something went wrong. Please try again later.',
            confirmButtonColor: '#dc3545'
          });
        }
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'There was a problem sending your application.',
          confirmButtonColor: '#dc3545'
        });
      }
    };
  return (
    <div style={{backgroundColor:'#cbcbcb'}}>
      <Header scrolled={scrolled}/>
      <div className='position-fixed p-2 px-5 w-100' style={{backgroundColor:'#cbcbcb',zIndex:'1'}}>
        <div className='d-flex gap-2' style={{marginLeft:'6%'}}>
          <div className='careerBtn bg-white p-2 fs-5' onClick={overview}>Overview</div>
          <div className='careerBtn bg-white p-2 fs-5' onClick={opportunity}>Opportunity</div>
        </div>
      </div>
      <div className='d-flex flex-column w-100' style={{padding:'6%',gap: '5rem'}}>
        <div className='d-flex careerSmallScreen1'>
          <div className='d-flex flex-column justify-content-center text-white gap-3' style={{backgroundColor:'cadetblue',padding:'3vw'}}>
            <div className='fs-2'>Why Kanwall Walia Associates?</div>
            <div style={{fontSize: '18px'}}>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque ipsa fugit necessitatibus dicta molestiae ducimus, eos libero repellendus unde, at ex nulla eius natus, voluptate accusamus. Nisi, reprehenderit dolores. Iusto maiores temporibus facilis accusantium repellendus velit, in similique perspiciatis illum ipsum optio assumenda odit sit dolorem. Reiciendis assumenda eum soluta perferendis a sint magni iste vel sunt dolor dolores, in ipsa, tempora iusto delectus excepturi voluptatum quisquam, nobis ratione! Sint laudantium repellat voluptas harum saepe, quae est quisquam rerum debitis aperiam nesciunt expedita error incidunt eligendi ex illum aut vel itaque earum quos quaerat! Nisi iste accusantium officia ad voluptate, illo provident ipsam dolores inventore magnam incidunt laborum autem animi, asperiores voluptates commodi accusamus impedit. Sint, laboriosam nihil? Aliquid explicabo atque iure ea. Aliquam vel, quod nam voluptate similique quam earum saepe. Quaerat, explicabo? Suscipit impedit accusamus repellendus ipsa ex vero cum voluptas pariatur saepe molestiae delectus dolores error eum excepturi non, consequatur maxime aliquam deleniti? Delectus rem provident soluta corporis omnis animi perferendis fugit magnam. Esse necessitatibus molestias eveniet. Consequatur praesentium, esse, debitis dolore nostrum tenetur voluptate dolorem quos mollitia aliquid possimus excepturi, cumque atque a! Voluptatem porro dolorum, omnis nisi quod consequatur animi, iste quia nobis repellendus sequi.</div>
          </div>
          <div className='careerImgDiv'><img src={career} alt='' className='w-100 h-100'></img><div></div></div>
        </div>
        <div className='d-flex flex-column p-2 justify-content-center align-items-center gap-2 w-100' style={{backgroundColor:'bisque'}}>
          <div className='fs-2'>Be A Part</div>
          <div className='d-flex w-100 justify-content-around'>
            <div className='BeAPartBox'>
              <div style={{display:'contents'}}><img src={lotus} style={{width:'70%'}} alt=''></img></div>
              <div>dfgdg</div>
            </div>
            <div className='BeAPartBox'>
              <div style={{display:'contents'}}><img src={lotus} style={{width:'70%'}} alt=''></img></div>
              <div>dfgdg</div>
            </div>
            <div className='BeAPartBox'>
              <div style={{display:'contents'}}><img src={lotus} style={{width:'70%'}} alt=''></img></div>
              <div>dfgdg</div>
            </div>
          </div>
        </div>
        <div className='d-flex flex-column gap-2'>
          <div style={{fontSize: '4vh'}} id='Opportunities'>Opportunities</div>
            <div>
            <div style={{fontSize: '3vh'}}>Internships</div>
            <div>Lorem ipsum dolor sit amet consectetur adipisicing elit. Id veniam impedit ut asperiores similique inventore numquam sapiente sunt quae, voluptates voluptas, labore nihil exercitationem, adipisci blanditiis quam cum et. Temporibus excepturi amet numquam doloremque omnis voluptate voluptates eos velit possimus error autem laudantium facilis quo doloribus, nihil aperiam blanditiis eveniet!</div>
          </div>
          <div>
            <div style={{fontSize: '3vh'}}>Professionals</div>
            <div>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil nam facilis nulla quis sed doloribus eos aliquid aliquam deserunt obcaecati! Laudantium architecto perspiciatis sit dolorum quidem nam quaerat aperiam. Magnam deleniti architecto dolores nemo magni obcaecati quo, error accusantium amet nesciunt dolore ducimus sunt temporibus. Nostrum natus culpa fugiat. Saepe!</div>
          </div>
          <div className='CareerApplyBtn p-1 fs-5 px-3' data-bs-toggle="modal" data-bs-target="#exampleModal">Apply</div>
        </div>
      </div>
      <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" style={{minWidth: '1050px'}}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Contact KWA Now</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className='d-flex justify-content-center align-items-center'>
                <table className='h-100' style={{width:'90%'}}>
                  <tbody>
                    <tr>
                      <td>Name</td>
                      <td><input type='text' className='form-control' name='name' onChange={handleChange} /></td>
                    </tr>
                    <tr>
                      <td>Contact</td>
                      <td><input type='number' className='form-control' name='contact' onChange={handleChange} /></td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td><input type='email' className='form-control' name='email' onChange={handleChange} /></td>
                    </tr>
                    <tr>
                      <td>Attachments</td>
                      <td>
                        <label className='p-1 px-3 careerAttachmentLabel' style={{border: '1px solid gray',borderRadius: '6px',cursor:'pointer'}} for='careerAttachment'>Attach</label>
                        <input type='file' id='careerAttachment' className='form-control' multiple onChange={handleFileChange} />
                      </td>
                    </tr>
                    <tr>
                      <td>Message</td>
                      <td><input type='text' className='form-control' name='message' onChange={handleChange} /></td>
                    </tr>
                  </tbody>                  
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-success" onClick={handleSubmit}>Send</button>
              <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Career
